import { Visible, Inline, Icon, Tooltip } from '@leroy-merlin-br/backyard-react-ui'
import { InfoCircle } from '@leroy-merlin-br/backyard-react-icons'

import * as S from './styled'

const FilterTitle = ({ filter = {} }) => {
  const { name = '', description = '', selected = false, options = [] } = filter

  return (
    <Inline justify="left" align="center" spacing="byte">
      {name}
      {description && (
        <Visible giga tera>
          <Tooltip placement="right" content={<span>{description}</span>}>
            <S.DescriptionButton>
              <Icon as={InfoCircle} size="kilo" />
            </S.DescriptionButton>
          </Tooltip>
        </Visible>
      )}
      {selected && (
        <S.Badge isLight color="green">
          {options.length}
        </S.Badge>
      )}
    </Inline>
  )
}

export default FilterTitle
